// extracted by mini-css-extract-plugin
export default {"filterCardsWrap":"filterCardsWrap--XnsTE"};